import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=7a9c735e"
import script from "./CatalogCard.vue?vue&type=script&lang=js"
export * from "./CatalogCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogCard.vue?vue&type=style&index=0&id=7a9c735e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports